import OpenModal from '../open-modal/open-modal';

const compareUrl = window.location.href.split('?')[0];
let compareButtons = document.querySelectorAll<HTMLButtonElement>('.product-grid__container .associated-product .js-product-compare');

export default () => {
    compareButtonSetup();
    selectedLoadCheck();
    compareSelected(); 
    clearComparedProducts(); 
};

const compareButtonSetup = () => {
    compareButtons = document.querySelectorAll<HTMLButtonElement>('.product-grid__container .associated-product .js-product-compare');
    if (compareButtons) {
        compareButtons.forEach(btn => {
            btn.removeEventListener('click', handleCompareClick);
            btn.addEventListener('click', handleCompareClick);
        });
    }
}

const handleCompareClick = (e: Event) => {
    e.preventDefault();
    const btn = (e.target as HTMLElement).closest('.btn') as HTMLButtonElement;
    const productID = btn.dataset.pid;

    //check if local storage exists
    if (localStorage.getItem(`productCompare${compareUrl}`) != null) {

        // if it does, get the array
        let compareArr = JSON.parse(localStorage.getItem(`productCompare${compareUrl}`));                    

        // if it exists, check if the product is in the array and remove it. If not, add it.
        if (compareArr.includes(productID)) {
            //remove active class & remove from array
            btn.classList.remove('active');
            //remove from array
            compareArr.splice(compareArr.indexOf(productID), 1);
        } else if (compareArr.length >= 3) {
            //if the array is full, alert the user and cancel the function
            alert('You can only compare 3 products at a time.');
            return;
        } else {
            // add active class to button & add to array
            btn.classList.add('active');
            compareArr.push(productID);
        }
        
        // push the new array to local storage                    
        setProductCompare(compareArr);
    }
    // if it doesnt exist, create it and add the product to it
    else {
        setProductCompare([productID]);
        btn.classList.add('active');  
    }         
    updateCompareCount();
};

export const selectedLoadCheck = () => {
    //on page load check local storage for the comapred attr, then add active to the buttons
    if (localStorage.getItem(`productCompare${compareUrl}`) != null) {
        let compareArr = JSON.parse(localStorage.getItem(`productCompare${compareUrl}`));
        compareArr.forEach((ID: string) => {
            const assocProduct = document.querySelector(`.js-product-compare[data-pid="${ID}"]`);
            assocProduct?.classList.add('active')
        });
        updateCompareCount();
    }
};

const updateCompareCount = () => {
    //update the compare button count & visibility
    const compareButtonPill = document.querySelector('.compare-buttons') as HTMLElement;
    const compareButton = document.querySelector('.js-compare-selected') as HTMLElement;
    const compareButtonCount = compareButton.querySelector('span') as HTMLSpanElement;
    
    if (localStorage.getItem(`productCompare${compareUrl}`) != null) {
        const compareCount = JSON.parse(localStorage.getItem(`productCompare${compareUrl}`)).length;
        compareButtonCount.innerText = compareCount;
        if (compareCount > 0) compareButtonPill.classList.add('active');
        else compareButtonPill.classList.remove('active');
    } else {
        compareButtonPill.classList.remove('active');   
        if (compareButtons) compareButtons.forEach(btn => btn.classList.remove('active'));
    }
};

export const compareSelected = () => {
    const compareButton = document.querySelector('.js-compare-selected') as HTMLLinkElement;
    compareButton?.addEventListener('click', (e) => {
        e.preventDefault();
        // GET THE ARRAY
        let compareArr = JSON.parse(localStorage.getItem(`productCompare${compareUrl}`));
        if (compareArr.length <= 1) alert('Please select at least 2 products to compare.');
        else {
            // GET THE URL
            const url = '/api/compare?productIds=' + compareArr.join(',');
            //ADD THE URL TO THE COMPARE BUTTON HREF 
            compareButton.href = url;
            compareButton.dataset.href = url;
            OpenModal(compareButton);
        }        
    });    
};

const setProductCompare = (arr: any ) => {
    localStorage.setItem(`productCompare${compareUrl}`, JSON.stringify(arr));    
};

const clearComparedProducts = () => {
    const removeCompare = document.querySelector('.js-remove-compared-items') as HTMLElement;
    removeCompare?.addEventListener('click', () => {
        localStorage.removeItem(`productCompare${compareUrl}`);
        updateCompareCount();
    }); 
};